import React, { useEffect, useState } from 'react'
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro'
import { UserDocument } from '../lib/userDocuments.slice'
import { Input } from '@/ui'

export interface DocumentSearchBarOnChangeData {
  filtered: UserDocument[]
  original: UserDocument[]
  value: string
}

export interface DocumentSearchBarProps {
  documents: UserDocument[]
  onChange: (_data: DocumentSearchBarOnChangeData) => void
}

export const DocumentsSearchBar: React.FC<DocumentSearchBarProps> = ({
  documents,
  onChange,
}) => {
  const [value, setValue] = useState('')

  // When value changes, filter documents and call onChange prop above
  useEffect(() => {
    const filtered = documents.filter((doc) => {
      const fileName = doc.awsFileName.toLowerCase()
      const description = doc.fileDescription?.toLowerCase()
      const query = value.toLocaleLowerCase()
      return fileName.includes(query) || description?.includes(query)
    })

    onChange({
      filtered,
      original: documents,
      value,
    })
  }, [value, onChange, documents])

  return (
    <Input
      iconLeft={regular('search')}
      iconRight={value.length > 0 ? regular('search') : undefined}
      type="search"
      placeholder="Search documents..."
      value={value}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
        setValue(event.target.value)
      }
    />
  )
}
